import { render } from "./AppCTA.vue?vue&type=template&id=145d41ed&scoped=true"
import script from "./AppCTA.vue?vue&type=script&lang=js"
export * from "./AppCTA.vue?vue&type=script&lang=js"

import "./AppCTA.vue?vue&type=style&index=0&id=145d41ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145d41ed"]])

export default __exports__